import { render } from "./VendorTable.vue?vue&type=template&id=20d7324b"
import script from "./VendorTable.vue?vue&type=script&lang=js"
export * from "./VendorTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__